var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('v-text-field',{attrs:{"value":_vm.descripcion,"label":_vm.titulo,"color":_vm.colores.primario,"dense":"","filled":"","readonly":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }